import { createSlice } from "@reduxjs/toolkit";

const otpSlice = createSlice({
  name: "otp",
  initialState: {
    loading: false,
    result: null,
    formData: {},
    phone: "",
  },
  reducers: {
    setOtpDataLoading(state) {
      state.loading = true;
    },
    setOtpDataSuccess: (state, action) => {
      state.loading = false;
      state.result = action.payload.result;
      state.formData = action.payload.formData;
      state.phone = action.payload.phone;
    },
    setOtpDataFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const { setOtpDataSuccess, setOtpDataLoading, setOtpDataFail } =
  otpSlice.actions;

export default otpSlice.reducer;
